import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
  name: 'CmgRetroCreditInfoModal',
})
export default class CmgRetroCreditInfoModal extends Vue {
  get args() {
    return this.$appStore.state.ui.modals.retroCreditReceiptModal.args;
  }

  get imageUrl(): string {
    return (this.args && this.args.imageUrl) || '';
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.retroCreditReceiptModal.visible;
  }

  get closeModalImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  get width(): string {
    const width = this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneXsMax ? 290 : 370;

    return `${width}px`;
  }

  onClose() {
    this.$services.ui.setModalVisibility('retroCreditReceiptModal', false);
  }
}
